export default function has(set, value) {
  return set?.has(value) || false;
}
